exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".verify-success[data-v-7a3653d9]{background-color:#3ab46b;font-weight:700;color:#fff;padding:8px}.verify-fail[data-v-7a3653d9]{background-color:#d9534f;font-weight:700;color:#fff;padding:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7a3653d9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/main/education/CourseCancelButton.vue
// module id = 777
// module chunks = 6